import { Edit, ShowButton, TopToolbar } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const EditUniversityForm = () => {
  return (
    <SecuredComponent permission={permissions.canManageExternalUniversities}>
      <Edit
        title="Редакция на университет"
        mutationMode="pessimistic"
        actions={
          <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
            <BackButtonToolbar
              additionalButton={
                <SecuredComponent permission={permissions.canPreviewExternalUniversities}>
                  <ShowButton
                    variant="contained"
                    size="medium"
                  />
                </SecuredComponent>
              }
            />
          </TopToolbar>
        }
      >
        <SaveForm toolbar={<InactiveDeleteOptionEditToolbar />} />
      </Edit>
    </SecuredComponent>
  );
};
export default EditUniversityForm;
